import { ActionFunctionArgs } from "react-router-dom";
import { myAxios } from "src/components/common/functions";

export async function helpAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    const res = await myAxios({
        fileName: "help/ask.php",
        formData,
        signal: controller.signal
    });
    return res?.data ?? null;
}
